// extracted by mini-css-extract-plugin
export default {"dropdown_indicator":"DropdownIndicator_dropdown_indicator__LG3EH"};